import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable()

export class LocalStorageServices {

  private LSCursorSubject = new BehaviorSubject(null);
  onUpdatedLSCursor = this.LSCursorSubject.asObservable();

  private LSCursors: object = { imageCursor: undefined, videoCursor: undefined };

  constructor() {}

  get( cursor?: any ): any {
    const deconstructedCursor: any = { year: undefined, month: undefined, page: undefined }
    if ( cursor ) {
      const lsCursorExists = localStorage.getItem( cursor ) ? localStorage.getItem( cursor ).split(',') : undefined;

      if ( lsCursorExists ) {
        lsCursorExists.forEach( (kvpair: any) => {
          let [key,value] = kvpair.split(':');
          value = value || parseInt(value) === 0 ? parseInt(value) : 1 ;
          deconstructedCursor[key] = value;
        });
      }

    }

    return deconstructedCursor;
  }

  set( cursor?: any ): any {
    if (cursor) {
      let key = Object.keys(cursor).toString();
      let cursorString = `year:${cursor[key].get('year')},month:${cursor[key].get('month')},page:${cursor[key].get('page')}`;
      localStorage.setItem( key, cursorString );
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/services/localStorage.services.ts